import React, {useCallback, useEffect, useRef} from 'react';
import {Number} from 'components/customer/Product/QuickAdd/NumberSpinner';
import {useQuickAddContext} from 'components/customer/Product/QuickAdd';
import {Form} from 'react-bootstrap';
import {isMobile} from 'react-device-detect';

interface WidthProps {
    id?: string;
}

export const Width = ({id}: WidthProps) => {
    const {
        width,
        setWidth,
        item,
        validationMessage,
        popoverOpen,
        setValidationMessage,
    } = useQuickAddContext();

    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (popoverOpen && !isMobile) {
            inputRef.current?.focus();
            inputRef.current?.select();
        }
    }, [popoverOpen]);

    const changeHandler = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const newValue = parseFloat(event.target.value);
            setWidth && setWidth(newValue);
            setValidationMessage && setValidationMessage('');
        },
        [setWidth]
    );

    return (
        <Form.Group>
            <Number
                ref={inputRef}
                id={id}
                value={width || ''}
                onChange={changeHandler}
                data-cy={item ? `width-${item.id}` : 'width'}
                type="number"
                isInvalid={validationMessage != ''}
            />
        </Form.Group>
    );
};
